import type { HTMLAttributes } from 'react';
import { pickCss } from '@/shared/lib/css-utils';
import css from './heading.module.scss';

const styles = pickCss(css, css.root);

type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
type HeadingSize = '2xl' | 'xl' | 'lg' | 'md' | 'sm';

type HeadingProps = HTMLAttributes<HTMLHeadingElement> & {
  as?: HeadingLevel;
  size?: HeadingSize;
  variant?: 'default' | 'accent';
};

export const Heading = ({
  as: Tag = 'h2',
  size = 'md',
  variant = 'default',
  className,
  children,
  ...restProps
}: HeadingProps) => (
  <Tag
    className={styles(
      { size, variant: variant !== 'default' ? variant : undefined },
      className
    )}
    {...restProps}
  >
    {children}
  </Tag>
);
